export default "Les CEE Bâtiment (BAT-EN, BAT-TH, BAT-EQ) permettent aux entreprises de financer leurs travaux d'efficacité énergétique. Découvrez les montants éligibles et démarrez votre dossier avec Solution Éco France.";
